import { getAvailabilityTemplate } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { asyncWait } from '@uplift/utils';
import { useQuery } from '@tanstack/react-query';

export const useFueCompleted = (requestThrottleMs = 0) => {
  const me = useCurrentuser();
  const { data: availabilityTemplate, isFetching } = useQuery({
    queryKey: [ 'fueCompleted', me.id ],
    queryFn: async () => {
      const [ availabilityResponse ] = await Promise.all([
        getAvailabilityTemplate(),
        asyncWait(requestThrottleMs, { configured: false }),
      ]);

      return availabilityResponse;
    },
    cacheTime: 0
  });

  return { fueCompleted: availabilityTemplate?.configured ?? null, isFetching };
};
